<template>
  <div v-loading="isLoading">
    <el-table
      :data="contacts"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="6">
              <p><strong>Title: </strong>{{ props.row.title || 'None' }}</p>
              <p><strong>Name: </strong>{{ props.row.name || 'None' }}</p>
              <p><strong>Address: </strong>{{ props.row.address || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Phone: </strong>{{ props.row.phone || 'None' }}</p>
              <p><strong>Mobile: </strong>{{ props.row.mobile || 'None' }}</p>
              <p><strong>Email: </strong>{{ props.row.email || 'None' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Include Billing: </strong>{{ props.row.include_billing ? 'YES' : 'No' }}</p>
              <p><strong>Include Pickups: </strong>{{ props.row.include_pickups ? 'YES' : 'No' }}</p>
            </el-col>
            <el-col :md="6">
              <p><strong>Notes: </strong></p>
              <p style="background-Color: #F5F5F5; padding: 5px;">
                {{ props.row.notes || 'None' }}
              </p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Name"
        prop="name"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Title"
        prop="title"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Contact Type"
        prop="contact_type"
        :formatter="(row, col, cellValue) => cellValue.long || '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editContact(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteContact(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>

    <!-- Edit Form -->
    <ContactEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :account-id="accountId"
      :contact="contact"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import ContactEditForm from '@/components/Application/Manage/Account/ContactEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    ContactEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    sort: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      contact: null,
      contacts: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_contact')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_contact')
    }
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_contact'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.contact = new this.$sdk.account_contact()
          this.isShowEditForm = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_contact.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.include = ['contact_type']
        builder.order = `${this.sort.field}:${this.sort.direction}`
        builder.filters = this.filters
      })
        .then(res => {
          this.contacts = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    editContact (index, row) {
      this.contact = row.clone()
      this.isShowEditForm = true
    },
    deleteContact (index, row) {
      this.$confirm('Are you sure to delete this contact?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
